import React, {
  ComponentType,
  NamedExoticComponent,
  ReactElement,
} from 'react';

import PrivateRoute from './PrivateRoute';
import Spinner from 'components/general/loaders/Spinner/Spinner';
import { useCurrentUser } from 'store/user';
import { useProjectId } from 'store/project';

interface GenericRoleAuthorizerProps {
  authorized: boolean;
  unauthorized: boolean;
  authorizedComponent: NamedExoticComponent | ComponentType<any>;
  unauthorizedComponent: NamedExoticComponent | ComponentType<any>;
}

function GenericRoleAuthorizer(
  props: GenericRoleAuthorizerProps
): ReactElement {
  const {
    authorized,
    unauthorized,
    authorizedComponent,
    unauthorizedComponent,
  } = props;
  const projectId = useProjectId();
  const currentUser = useCurrentUser();

  if (!currentUser._id || !projectId) {
    return (
      <Spinner
        reason={`!currentUser._id: ${currentUser._id}, !project._id: ${projectId}`}
      />
    );
  }

  if (authorized) {
    return (
      <React.Suspense fallback={null}>
        <PrivateRoute element={authorizedComponent} />
      </React.Suspense>
    );
  }

  if (unauthorized) {
    const UnauthorizedComponent = unauthorizedComponent;
    return <UnauthorizedComponent />;
  }

  return <Spinner reason={'GenericRoleAuthorizer fallback'} />;
}

export const MemoGenericRoleAuthorizer = React.memo(GenericRoleAuthorizer);
